export const getVehicleRequestUrl = (scsUrlParts, vehicleId = '') => {
    if (!scsUrlParts ||
        !scsUrlParts.scsBaseUrl ||
        !scsUrlParts.language ||
        !scsUrlParts.market ||
        !scsUrlParts.defaultVersion ||
        !vehicleId) {
        return '';
    }
    const scsAPIurl = `${scsUrlParts.scsBaseUrl}${scsUrlParts.defaultVersion}/vehicles/vehicle/${scsUrlParts.language}/${scsUrlParts.market}`;
    return `${scsAPIurl}/${vehicleId}`;
};
export function generateRequestParamString(url, params = new Map()) {
    const getParams = [];
    for (const [parameterKey, parameter] of params.entries()) {
        if (parameter) {
            const encodedParameter = encodeURIComponent(parameter);
            getParams.push(`${parameterKey}=${encodedParameter}`);
        }
    }
    return `${url}${getParams.length ? `?${getParams.join('&')}` : ''}`;
}
